import React from 'react';
import { notificationTypes } from '../../constants';
import successIcon from '../../../img/Icons_Feedback_Success.svg';
import warningIcon from '../../../img/Icons_Feedback_Warning.svg';
import errorIcon from '../../../img/Icons_Feedback_Error.svg';
import infoIcon from '../../../img/Icons_Feedback_Info.svg';

const iconMap = {
    [notificationTypes.SUCCESS]: successIcon,
    [notificationTypes.WARNING]: warningIcon,
    [notificationTypes.ERROR]: errorIcon,
    [notificationTypes.INFO]: infoIcon,
};

const Notification = ({ id, type, message, isPersistent = false, onRemove }) => (
    <div className={`toast-notification ${type}`}>
        <img src={iconMap[type]} width={24} height={24} alt={`${type}`} />
        <span className="toast-notification-message">{ message }</span>
        {
            isPersistent
                ? <button className="toast-notification-dismiss" onClick={() => onRemove(id)}>×</button>
                : null
        }
    </div>
);

export default Notification;
